/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { CommunicationsCommentsCommentModel } from '@coin/shared/core/util-models';
import { EmployeesEmployeesEmployeeModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalDashboardHeadcountApprovalDashboardModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalEmployeeReferenceEmployeeModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobAdJobAdModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobAdPrepareJobAdModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobAdReviewJobAdModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobAdReviewJobAdResultModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobAdTranslateJobAdModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobAdTranslateJobAdResultModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobDescriptionsCreateJobDescriptionModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobDescriptionsEnhanceJobDescriptionModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobDescriptionsGenerateJobDescriptionModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobDescriptionsJobDescriptionModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalJobDescriptionsUpdateJobDescriptionModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestCommentsCreatePositionRequestCommentModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestDraftsCreatePositionRequestDraftModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestDraftsUpdatePositionRequestDraftModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestPlansCreatePositionRequestPlanModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestPlansUpdatePositionRequestPlanModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsAcknowledgePositionRequestModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsCreatePositionRequestModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsDashboardModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsPositionRequestModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsPositionRequestPlanDashboardModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsTransferPositionRequestModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsUpdatePositionRequestModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsValidationPositionRequestValidationResponseModel } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionRequestsValidationValidatePositionRequestInputQuery } from '@coin/shared/core/util-models';
import { HeadcountApprovalPositionSurveyHeadcountApprovalPositionSurveyDataModel } from '@coin/shared/core/util-models';
import { SharedFieldValuesModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfEmployeesEmployeesEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountApprovalJobDescriptionsMinimalJobDescriptionModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountApprovalPositionRequestDraftsPositionRequestDraftModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountApprovalPositionRequestsPositionRequestModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfUsersClusterNodesClusterNodeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfUsersClusterNodesCountryClusterNodeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfUsersClustersClusterModel } from '@coin/shared/core/util-models';
import { SiemensEnergyCOINHeadcountApiResponsesMercerJobCodeResponse } from '@coin/shared/core/util-models';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models';
import { TransactionStatusOfJobAdGenerationMetadata } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface HeadcountApprovalCustomerServiceAcknowledgePositionRequestsRequestParams {
  /** The unqique id of the position request to acknowledge an approval of. */
  id: string;
  /** The unique id of the approval to acknowledge. */
  approvalId: string;
  /** The date of the last refresh of the requester to be able to assure the request has not been updated in the meantime. */
  ifUnmodifiedSince?: string;
  /** The model data to acknowledge the approval with. */
  headcountApprovalPositionRequestsAcknowledgePositionRequestModel?: HeadcountApprovalPositionRequestsAcknowledgePositionRequestModel;
}

export interface HeadcountApprovalCustomerServiceCreateJobDescriptionsRequestParams {
  /** The model data to create the job description with. */
  headcountApprovalJobDescriptionsCreateJobDescriptionModel?: HeadcountApprovalJobDescriptionsCreateJobDescriptionModel;
}

export interface HeadcountApprovalCustomerServiceCreatePositionRequestCommentsRequestParams {
  /** The unique id of the existing position request. */
  positionRequestId: string;
  /** The model data to create the comment with. */
  headcountApprovalPositionRequestCommentsCreatePositionRequestCommentModel?: HeadcountApprovalPositionRequestCommentsCreatePositionRequestCommentModel;
}

export interface HeadcountApprovalCustomerServiceCreatePositionRequestDraftsRequestParams {
  /** The model data to create the position request draft with. */
  headcountApprovalPositionRequestDraftsCreatePositionRequestDraftModel?: HeadcountApprovalPositionRequestDraftsCreatePositionRequestDraftModel;
}

export interface HeadcountApprovalCustomerServiceCreatePositionRequestsRequestParams {
  /** The model data to create the position request with. */
  headcountApprovalPositionRequestsCreatePositionRequestModel?: HeadcountApprovalPositionRequestsCreatePositionRequestModel;
}

export interface HeadcountApprovalCustomerServiceDeleteJobDescriptionSessionJobDescriptionRequestParams {
  sessionId: string;
}

export interface HeadcountApprovalCustomerServiceDeletePositionRequestDraftsRequestParams {
  /** The unique id of the position request draft to delete. */
  id: string;
}

export interface HeadcountApprovalCustomerServiceDeletePositionRequestPlanPositionRequestPlansRequestParams {
  /** The unique id of the position request plan to delete. */
  id: string;
}

export interface HeadcountApprovalCustomerServiceDeletePositionRequestsRequestParams {
  /** The unique id of the position request to delete. */
  id: string;
}

export interface HeadcountApprovalCustomerServiceEnhanceJobDescriptionJobDescriptionRequestParams {
  headcountApprovalJobDescriptionsEnhanceJobDescriptionModel?: HeadcountApprovalJobDescriptionsEnhanceJobDescriptionModel;
}

export interface HeadcountApprovalCustomerServiceExportPositionRequestsRequestParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The office types of the position request. */
  officeType?: Array<'CoreOffice' | 'NonCoreOffice'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
  /** The state of the position request export. */
  exportState?: 'Open' | 'Done';
  /** The filename of the position request export. */
  filename?: string;
}

export interface HeadcountApprovalCustomerServiceGenerateJobDescriptionJobDescriptionRequestParams {
  headcountApprovalJobDescriptionsGenerateJobDescriptionModel?: HeadcountApprovalJobDescriptionsGenerateJobDescriptionModel;
}

export interface HeadcountApprovalCustomerServiceGetByIdJobAdsRequestParams {
  /** The ID of the job ad to retrieve. */
  id: string;
}

export interface HeadcountApprovalCustomerServiceGetByIdJobDescriptionsRequestParams {
  /** The ID of the job description to retrieve. */
  id: string;
}

export interface HeadcountApprovalCustomerServiceGetByIdPositionRequestsRequestParams {
  /** The unique id of the position request. */
  id: string;
}

export interface HeadcountApprovalCustomerServiceGetHiringManagersEmployeeMasterDataRequestParams {
  search?: string;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServiceGetOrganisationHiringManagerOrganisationsRequestParams {
  orgCode: string;
}

export interface HeadcountApprovalCustomerServiceGetPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreasRequestParams {
  page?: number;
  size?: number;
  /** The search text to compare business areas with. */
  search?: string;
}

export interface HeadcountApprovalCustomerServiceGetPositionRequestPlanDashboardPositionRequestPlanDashboardRequestParams {
  /** The request type of the position request. */
  requestType?: Array<'Addition' | 'Replacement'>;
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: Array<'BestCost' | 'HighCost'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: Array<'Head' | 'Employee'>;
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface HeadcountApprovalCustomerServiceGetPositionRequestPlanFieldValuesPositionRequestPlanFieldValuesRequestParams {
  page?: number;
  size?: number;
  /** The request type of the position request. */
  requestType?: string;
  /** The organization codes of the position request. */
  orgCode?: string;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: string;
  /** The requester gids of the position request. */
  hiringManagerGid?: string;
  /** The position classes of the position request. */
  positionClass?: string;
  /** The organization levels of the position request. */
  orgLevel?: string;
  /** The position type of the position request. */
  positionType?: string;
  /** The query type of the position request. */
  workforceType?: string;
  /** WorkTimeType of the employee. */
  workTimeType?: string;
  /** The property for which to return field-values. */
  targetProperty?:
    | 'RequestType'
    | 'CountryGeoClusterNodeId'
    | 'NMinusOneLevelClusterNodeId'
    | 'OrgCode'
    | 'LocationType'
    | 'HiringManagerGid'
    | 'PositionClass'
    | 'OrgLevel'
    | 'PositionType'
    | 'WorkforceType'
    | 'WorkTimeType'
    | 'AreCode'
    | 'DepthStructure'
    | 'CostCenter'
    | 'Country'
    | 'Region';
}

export interface HeadcountApprovalCustomerServiceGetPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreasRequestParams {
  /** The business-area of which to get n-minus-one-levels for. */
  businessAreaId: string;
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServiceGetPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodesRequestParams {
  /** The search text to compare orgcodes with. */
  search?: string;
  /** The search text orgcodes have to start with. */
  orgCodeStartsWith?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface HeadcountApprovalCustomerServiceGetPositionRequestPlanPagePositionRequestPlansRequestParams {
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  /** The request type of the position request. */
  requestType?: Array<'Addition' | 'Replacement'>;
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: string;
  /** The location type of the position request. */
  locationType?: Array<'BestCost' | 'HighCost'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: Array<'Head' | 'Employee'>;
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface HeadcountApprovalCustomerServiceGetPositionSurveyDataHeadcountApprovalRequestParams {
  /** The organisation\&#39;s code of a position to request survey data for. */
  orgCode: string;
  /** The ISO2 country code of a position to request survey data for. */
  countryIsoAlpha2?: string;
  /** The derived position class of a position to request survey data for. */
  positionClass?: number;
  /** The mercer job code to get matching position survey data for. */
  siemensEnergyCOINHeadcountApiResponsesMercerJobCodeResponse?: SiemensEnergyCOINHeadcountApiResponsesMercerJobCodeResponse;
}

export interface HeadcountApprovalCustomerServiceGetStatesDashboardPositionRequestsRequestParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The office types of the position request. */
  officeType?: Array<'CoreOffice' | 'NonCoreOffice'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface HeadcountApprovalCustomerServicePagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployeesRequestParams {
  /** The search text to filter directs with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServicePagePositionRequestReplacementEmployeesPositionRequestReplacementEmployeesRequestParams {
  /** The search text to filter directs with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServicePostPositionRequestPlanPositionRequestPlansRequestParams {
  /** The model data to create the position request plan with. */
  headcountApprovalPositionRequestPlansCreatePositionRequestPlanModel?: HeadcountApprovalPositionRequestPlansCreatePositionRequestPlanModel;
}

export interface HeadcountApprovalCustomerServicePostPositionRequestTransferPositionRequestsRequestParams {
  /** The unique id of the position request to transfer. */
  id: string;
  /** The model data containing the target organization and optional new start date. */
  headcountApprovalPositionRequestsTransferPositionRequestModel?: HeadcountApprovalPositionRequestsTransferPositionRequestModel;
}

export interface HeadcountApprovalCustomerServicePrepareJobAdsRequestParams {
  /** The position request data, the job description to write the job ads from, and the documents it was generated from. */
  headcountApprovalJobAdPrepareJobAdModel?: HeadcountApprovalJobAdPrepareJobAdModel;
}

export interface HeadcountApprovalCustomerServicePutPositionRequestPlanPositionRequestPlansRequestParams {
  /** The unique id of the position request plan to update. */
  id: string;
  /** The model data to update the existing position request plan with. */
  headcountApprovalPositionRequestPlansUpdatePositionRequestPlanModel?: HeadcountApprovalPositionRequestPlansUpdatePositionRequestPlanModel;
}

export interface HeadcountApprovalCustomerServiceQueryBusinessAreaNMinusOneLevelsBusinessAreasRequestParams {
  businessAreaId: string;
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServiceQueryBusinessAreasBusinessAreasRequestParams {
  /** The search text to compare business areas with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServiceQueryEmployeeMasterDataEmployeeMasterDataRequestParams {
  employeeId: string;
}

export interface HeadcountApprovalCustomerServiceQueryFieldValuesPositionRequestsRequestParams {
  /** The target property of the position request field value. */
  targetProperty:
    | 'State'
    | 'PendingApprovalStepName'
    | 'RequestType'
    | 'CountryGeoClusterNodeId'
    | 'NMinusOneLevelClusterNodeId'
    | 'OrgCode'
    | 'LocationType'
    | 'OfficeType'
    | 'HiringManagerGid'
    | 'PositionClass'
    | 'OrgLevel'
    | 'PositionType'
    | 'WorkforceType'
    | 'WorkTimeType'
    | 'ReferenceNumber'
    | 'AreCode'
    | 'DepthStructure'
    | 'CostCenter'
    | 'Country'
    | 'Region';
  pagingPage?: number;
  pagingSize?: number;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?:
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed';
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node id of the position request. */
  countryGeoClusterNodeId?: string;
  /** The n-1 level cluster node id of the position request. */
  nMinusOneLevelClusterNodeId?: string;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The office type of the position request. */
  officeType?: 'CoreOffice' | 'NonCoreOffice';
  /** The requester gid of the position request. */
  hiringManagerGid?: string;
  /** The position class of the position request. */
  positionClass?: number;
  /** The organization code of the position request. */
  orgCode?: string;
  /** The organization level of the position request. */
  orgLevel?: number;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The workforce type of the position request. */
  workforceType?:
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal';
  /** WorkTimeType of the employee. */
  workTimeType?: 'Either' | 'FullTime' | 'PartTime';
  /** Reference number in COIN. */
  referenceNumber?: number;
  /** Legal entity / are code of the position request. */
  areCode?: string;
  /** Depth Structure of the position request. */
  depthStructure?: string;
  /** Cost Center of the position request. */
  costCenter?: string;
  /** Any one of the countries of the position request. */
  country?: string;
  /** Any one of the regions of the position request. */
  region?: string;
}

export interface HeadcountApprovalCustomerServiceQueryJobDescriptionsRequestParams {
  /** The organisational code. */
  orgCode: string;
  /** The unique id of the job code (from Mercer). */
  jobCodeId?: string;
  /** The search text to search the title */
  search?: string;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServiceQueryOrgCodesHeadcountApprovalRequestParams {
  /** The search text to compare orgcodes with. */
  search?: string;
  /** The search text orgcodes have to start with. */
  orgCodeStartsWith?: string;
  pagingPage?: number;
  pagingSize?: number;
}

export interface HeadcountApprovalCustomerServiceQueryPositionRequestCommentsRequestParams {
  /** The unique id of the position request to return comments of. */
  positionRequestId: string;
}

export interface HeadcountApprovalCustomerServiceQueryPositionRequestsRequestParams {
  pagingPage?: number;
  pagingSize?: number;
  sortingOrderBy?: 'Asc' | 'Desc';
  sortingProperty?: string;
  /** The pending approval step name of the position request. */
  pendingApprovalStepName?: Array<
    | 'Planned'
    | 'Draft'
    | 'Submitted'
    | 'GlobalHrApprover'
    | 'RegionalHrApprover'
    | 'CbApprover'
    | 'NMinusOneApprover'
    | 'NMinusTwoApprover'
    | 'HeadOneApprover'
    | 'HeadTwoApprover'
    | 'HeadNMinusOneApprover'
    | 'HeadNMinusTwoApprover'
    | 'HeadNMinusThreeApprover'
    | 'SelfValidation'
    | 'Approved'
    | 'Rejected'
    | 'Cancelled'
    | 'Vetoed'
  >;
  /** The request type of the position request. */
  requestType?: 'Addition' | 'Replacement';
  /** The country geo cluster node ids of the position request. */
  countryGeoClusterNodeId?: Array<string>;
  /** The n-1 level cluster node ids of the position request. */
  nMinusOneLevelClusterNodeId?: Array<string>;
  /** The organization codes of the position request. */
  orgCode?: Array<string>;
  /** The organization codes starts with of the position request. */
  orgCodeStartsWith?: Array<string>;
  /** The location type of the position request. */
  locationType?: 'BestCost' | 'HighCost';
  /** The office types of the position request. */
  officeType?: Array<'CoreOffice' | 'NonCoreOffice'>;
  /** The requester gids of the position request. */
  hiringManagerGid?: Array<string>;
  /** The position classes of the position request. */
  positionClass?: Array<number>;
  /** The organization levels of the position request. */
  orgLevel?: Array<number>;
  /** The position type of the position request. */
  positionType?: 'Head' | 'Employee';
  /** The query type of the position request. */
  queryType?: 'InMyJurisdiction' | 'RequiresMyAction';
  /** The query type of the position request. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** WorkTimeType of the employee. */
  workTimeType?: Array<'Either' | 'FullTime' | 'PartTime'>;
  /** Reference Number in COIN. */
  referenceNumber?: Array<number>;
  /** Legal entity / are code of the position request. */
  areCode?: Array<string>;
  /** Depth Structure of the position request. */
  depthStructure?: Array<string>;
  /** Cost Center of the position request. */
  costCenter?: Array<string>;
  /** Any one of the countries of the position request. */
  country?: Array<string>;
  /** Any one of the regions of the position request. */
  region?: Array<string>;
  /** StartDate of the position request is after this. */
  startDate?: string;
  /** StartDate of the position request is before this. */
  endDate?: string;
}

export interface HeadcountApprovalCustomerServiceQueryReferenceEmployeesEmployeeMasterDataRequestParams {
  orgCode: string;
  search?: string;
}

export interface HeadcountApprovalCustomerServiceQueryRegionCountriesCountriesRequestParams {
  /** The search text to compare business areas with. */
  search?: string;
  regionIds?: Array<string>;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServiceQueryRegionsRegionsRequestParams {
  /** The search text to compare regions with. */
  search?: string;
  page?: number;
  size?: number;
}

export interface HeadcountApprovalCustomerServiceReviewJobAdsRequestParams {
  /** The resolved template, the job ad to check, and the job description it was written from. */
  headcountApprovalJobAdReviewJobAdModel?: HeadcountApprovalJobAdReviewJobAdModel;
}

export interface HeadcountApprovalCustomerServiceTranslateJobAdsRequestParams {
  /** The resolved template, the job ad to translate, and the language to add. */
  headcountApprovalJobAdTranslateJobAdModel?: HeadcountApprovalJobAdTranslateJobAdModel;
}

export interface HeadcountApprovalCustomerServiceUpdateJobDescriptionsRequestParams {
  /** The ID of the job description to update. */
  id: string;
  /** The updated job description data. */
  headcountApprovalJobDescriptionsUpdateJobDescriptionModel?: HeadcountApprovalJobDescriptionsUpdateJobDescriptionModel;
}

export interface HeadcountApprovalCustomerServiceUpdatePositionRequestDraftsRequestParams {
  /** The unique id of the position request draft to update. */
  id: string;
  /** The model data to update the existing position request draft with. */
  headcountApprovalPositionRequestDraftsUpdatePositionRequestDraftModel?: HeadcountApprovalPositionRequestDraftsUpdatePositionRequestDraftModel;
}

export interface HeadcountApprovalCustomerServiceUpdatePositionRequestsRequestParams {
  /** The unique id of the position request to update (or the unique id of the draft to create the position request from). */
  id: string;
  /** The model data to update an existing position request with (or the model data to create a new position request from a position request draft). */
  headcountApprovalPositionRequestsUpdatePositionRequestModel?: HeadcountApprovalPositionRequestsUpdatePositionRequestModel;
}

export interface HeadcountApprovalCustomerServiceValidatePositionRequestsRequestParams {
  /** The position request input to validate. */
  headcountApprovalPositionRequestsValidationValidatePositionRequestInputQuery?: HeadcountApprovalPositionRequestsValidationValidatePositionRequestInputQuery;
}

export interface HeadcountApprovalCustomerServiceVetoPositionRequestsRequestParams {
  /** The unique id of the position request to veto. */
  id: string;
}

/**
 * @deprecated The v1 API client is deprecated. Use the v2 client from `@coin/shared/core/data-access-v2` instead.
 */
@Injectable({
  providedIn: 'root'
})
export class HeadcountApprovalCustomerService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Acknowledges a specific, existing approval of an existing position request by their unique ids.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acknowledgePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceAcknowledgePositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsPositionRequestModel>;
  public acknowledgePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceAcknowledgePositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public acknowledgePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceAcknowledgePositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public acknowledgePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceAcknowledgePositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling acknowledgePositionRequests.');
    }
    const approvalId = requestParameters?.approvalId;
    if (approvalId === null || approvalId === undefined) {
      throw new Error('Required parameter approvalId was null or undefined when calling acknowledgePositionRequests.');
    }
    const ifUnmodifiedSince = requestParameters?.ifUnmodifiedSince;
    const headcountApprovalPositionRequestsAcknowledgePositionRequestModel =
      requestParameters?.headcountApprovalPositionRequestsAcknowledgePositionRequestModel;

    let localVarHeaders = this.defaultHeaders;
    if (ifUnmodifiedSince !== undefined && ifUnmodifiedSince !== null) {
      localVarHeaders = localVarHeaders.set('If-Unmodified-Since', String(ifUnmodifiedSince));
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/approvals/${this.configuration.encodeParam({ name: 'approvalId', value: approvalId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/acknowledge`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsPositionRequestModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestsAcknowledgePositionRequestModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a new job description.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceCreateJobDescriptionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalJobDescriptionsJobDescriptionModel>;
  public createJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceCreateJobDescriptionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalJobDescriptionsJobDescriptionModel>>;
  public createJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceCreateJobDescriptionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalJobDescriptionsJobDescriptionModel>>;
  public createJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceCreateJobDescriptionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalJobDescriptionsCreateJobDescriptionModel =
      requestParameters?.headcountApprovalJobDescriptionsCreateJobDescriptionModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-descriptions`;
    return this.httpClient.request<HeadcountApprovalJobDescriptionsJobDescriptionModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalJobDescriptionsCreateJobDescriptionModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a new comment for an existing position request.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequestComments(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestCommentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<CommunicationsCommentsCommentModel>;
  public createPositionRequestComments(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestCommentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<CommunicationsCommentsCommentModel>>;
  public createPositionRequestComments(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestCommentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<CommunicationsCommentsCommentModel>>;
  public createPositionRequestComments(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestCommentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    if (positionRequestId === null || positionRequestId === undefined) {
      throw new Error(
        'Required parameter positionRequestId was null or undefined when calling createPositionRequestComments.'
      );
    }
    const headcountApprovalPositionRequestCommentsCreatePositionRequestCommentModel =
      requestParameters?.headcountApprovalPositionRequestCommentsCreatePositionRequestCommentModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`;
    return this.httpClient.request<CommunicationsCommentsCommentModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestCommentsCreatePositionRequestCommentModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a new position request draft.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestDraftsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>;
  public createPositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestDraftsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public createPositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestDraftsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public createPositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestDraftsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalPositionRequestDraftsCreatePositionRequestDraftModel =
      requestParameters?.headcountApprovalPositionRequestDraftsCreatePositionRequestDraftModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/drafts`;
    return this.httpClient.request<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestDraftsCreatePositionRequestDraftModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a new position request.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsPositionRequestModel>;
  public createPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public createPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public createPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceCreatePositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalPositionRequestsCreatePositionRequestModel =
      requestParameters?.headcountApprovalPositionRequestsCreatePositionRequestModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsPositionRequestModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestsCreatePositionRequestModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteJobDescriptionSessionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceDeleteJobDescriptionSessionJobDescriptionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteJobDescriptionSessionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceDeleteJobDescriptionSessionJobDescriptionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteJobDescriptionSessionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceDeleteJobDescriptionSessionJobDescriptionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteJobDescriptionSessionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceDeleteJobDescriptionSessionJobDescriptionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const sessionId = requestParameters?.sessionId;
    if (sessionId === null || sessionId === undefined) {
      throw new Error(
        'Required parameter sessionId was null or undefined when calling deleteJobDescriptionSessionJobDescription.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/job-description/sessions/${this.configuration.encodeParam({ name: 'sessionId', value: sessionId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Deletes an existing position request draft by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestDraftsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestDraftsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestDraftsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestDraftsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePositionRequestDrafts.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/drafts/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Deletes an existing position request plan by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestPlanPositionRequestPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deletePositionRequestPlanPositionRequestPlans.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Deletes an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deletePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deletePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deletePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deletePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceDeletePositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling deletePositionRequests.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public enhanceJobDescriptionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceEnhanceJobDescriptionJobDescriptionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel>;
  public enhanceJobDescriptionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceEnhanceJobDescriptionJobDescriptionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel>>;
  public enhanceJobDescriptionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceEnhanceJobDescriptionJobDescriptionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel>>;
  public enhanceJobDescriptionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceEnhanceJobDescriptionJobDescriptionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalJobDescriptionsEnhanceJobDescriptionModel =
      requestParameters?.headcountApprovalJobDescriptionsEnhanceJobDescriptionModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/job-description/enhancement`;
    return this.httpClient.request<HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalJobDescriptionsEnhanceJobDescriptionModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Exports existing position requests by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceExportPositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceExportPositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceExportPositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceExportPositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pendingApprovalStepName = requestParameters?.pendingApprovalStepName;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const officeType = requestParameters?.officeType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const queryType = requestParameters?.queryType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const referenceNumber = requestParameters?.referenceNumber;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const exportState = requestParameters?.exportState;
    const filename = requestParameters?.filename;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pendingApprovalStepName) {
      pendingApprovalStepName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'PendingApprovalStepName'
        );
      });
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (officeType) {
      officeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OfficeType');
      });
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'QueryType');
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (referenceNumber) {
      referenceNumber.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ReferenceNumber');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (exportState !== undefined && exportState !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>exportState, 'ExportState');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public generateJobDescriptionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceGenerateJobDescriptionJobDescriptionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel>;
  public generateJobDescriptionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceGenerateJobDescriptionJobDescriptionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel>>;
  public generateJobDescriptionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceGenerateJobDescriptionJobDescriptionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel>>;
  public generateJobDescriptionJobDescription(
    requestParameters?: HeadcountApprovalCustomerServiceGenerateJobDescriptionJobDescriptionRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalJobDescriptionsGenerateJobDescriptionModel =
      requestParameters?.headcountApprovalJobDescriptionsGenerateJobDescriptionModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/job-description/generation`;
    return this.httpClient.request<HeadcountApprovalJobDescriptionsGeneratedJobDescriptionModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalJobDescriptionsGenerateJobDescriptionModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets a job ad by its ID.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdJobAdsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalJobAdJobAdModel>;
  public getByIdJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdJobAdsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalJobAdJobAdModel>>;
  public getByIdJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdJobAdsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalJobAdJobAdModel>>;
  public getByIdJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdJobAdsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getByIdJobAds.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-ads/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalJobAdJobAdModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets a job description by its ID.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdJobDescriptionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalJobDescriptionsJobDescriptionModel>;
  public getByIdJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdJobDescriptionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalJobDescriptionsJobDescriptionModel>>;
  public getByIdJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdJobDescriptionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalJobDescriptionsJobDescriptionModel>>;
  public getByIdJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdJobDescriptionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getByIdJobDescriptions.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-descriptions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalJobDescriptionsJobDescriptionModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets an existing position request by its id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getByIdPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdPositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsPositionRequestModel>;
  public getByIdPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdPositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public getByIdPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdPositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public getByIdPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceGetByIdPositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getByIdPositionRequests.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsPositionRequestModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets the headcount approval dashboard values.
   * Values are shown in Frontend when initially opening headcount approval. They provide a quick overview of position requests the current user has access to or is involved in.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDashboardHeadcountApproval(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalDashboardHeadcountApprovalDashboardModel>;
  public getDashboardHeadcountApproval(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalDashboardHeadcountApprovalDashboardModel>>;
  public getDashboardHeadcountApproval(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalDashboardHeadcountApprovalDashboardModel>>;
  public getDashboardHeadcountApproval(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/dashboard`;
    return this.httpClient.request<HeadcountApprovalDashboardHeadcountApprovalDashboardModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getHiringManagersEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceGetHiringManagersEmployeeMasterDataRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfEmployeesEmployeesEmployeeModel>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceGetHiringManagersEmployeeMasterDataRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceGetHiringManagersEmployeeMasterDataRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfEmployeesEmployeesEmployeeModel>>;
  public getHiringManagersEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceGetHiringManagersEmployeeMasterDataRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/employee/hiring-managers`;
    return this.httpClient.request<SharedPageModelOfEmployeesEmployeesEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: HeadcountApprovalCustomerServiceGetOrganisationHiringManagerOrganisationsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<EmployeesEmployeesEmployeeModel>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: HeadcountApprovalCustomerServiceGetOrganisationHiringManagerOrganisationsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<EmployeesEmployeesEmployeeModel>>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: HeadcountApprovalCustomerServiceGetOrganisationHiringManagerOrganisationsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<EmployeesEmployeesEmployeeModel>>;
  public getOrganisationHiringManagerOrganisations(
    requestParameters?: HeadcountApprovalCustomerServiceGetOrganisationHiringManagerOrganisationsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error(
        'Required parameter orgCode was null or undefined when calling getOrganisationHiringManagerOrganisations.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/organisations/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/hiring-manager`;
    return this.httpClient.request<EmployeesEmployeesEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries position request plan business-areas of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreasRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfUsersClustersClusterModel>;
  public getPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreasRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfUsersClustersClusterModel>>;
  public getPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreasRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfUsersClustersClusterModel>>;
  public getPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanBusinessAreaPagePositionRequestPlanBusinessAreasRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const search = requestParameters?.search;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/business-areas`;
    return this.httpClient.request<SharedPageModelOfUsersClustersClusterModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets a dashboard overview of counts of position request plans.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionRequestPlanDashboardPositionRequestPlanDashboard(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanDashboardPositionRequestPlanDashboardRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsPositionRequestPlanDashboardModel>;
  public getPositionRequestPlanDashboardPositionRequestPlanDashboard(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanDashboardPositionRequestPlanDashboardRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsPositionRequestPlanDashboardModel>>;
  public getPositionRequestPlanDashboardPositionRequestPlanDashboard(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanDashboardPositionRequestPlanDashboardRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsPositionRequestPlanDashboardModel>>;
  public getPositionRequestPlanDashboardPositionRequestPlanDashboard(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanDashboardPositionRequestPlanDashboardRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (requestType) {
      requestType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RequestType');
      });
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (locationType) {
      locationType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LocationType');
      });
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType) {
      positionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionType');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/dashboard`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsPositionRequestPlanDashboardModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries position request plan field values of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionRequestPlanFieldValuesPositionRequestPlanFieldValues(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanFieldValuesPositionRequestPlanFieldValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedFieldValuesModel>;
  public getPositionRequestPlanFieldValuesPositionRequestPlanFieldValues(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanFieldValuesPositionRequestPlanFieldValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedFieldValuesModel>>;
  public getPositionRequestPlanFieldValuesPositionRequestPlanFieldValues(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanFieldValuesPositionRequestPlanFieldValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedFieldValuesModel>>;
  public getPositionRequestPlanFieldValuesPositionRequestPlanFieldValues(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanFieldValuesPositionRequestPlanFieldValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const requestType = requestParameters?.requestType;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const targetProperty = requestParameters?.targetProperty;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (hiringManagerGid !== undefined && hiringManagerGid !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hiringManagerGid,
        'HiringManagerGid'
      );
    }
    if (positionClass !== undefined && positionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionClass, 'PositionClass');
    }
    if (orgLevel !== undefined && orgLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgLevel, 'OrgLevel');
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (workforceType !== undefined && workforceType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workforceType, 'WorkforceType');
    }
    if (workTimeType !== undefined && workTimeType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workTimeType, 'WorkTimeType');
    }
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'targetProperty');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/field-values`;
    return this.httpClient.request<SharedFieldValuesModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Queries existing n-1 levels of a business area by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreasRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfUsersClusterNodesClusterNodeModel>;
  public getPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreasRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfUsersClusterNodesClusterNodeModel>>;
  public getPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreasRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfUsersClusterNodesClusterNodeModel>>;
  public getPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreasRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const businessAreaId = requestParameters?.businessAreaId;
    if (businessAreaId === null || businessAreaId === undefined) {
      throw new Error(
        'Required parameter businessAreaId was null or undefined when calling getPositionRequestPlanNMinusOneLevelPagePositionRequestPlanBusinessAreas.'
      );
    }
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/business-areas/${this.configuration.encodeParam({ name: 'businessAreaId', value: businessAreaId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/n-minus-one-levels`;
    return this.httpClient.request<SharedPageModelOfUsersClusterNodesClusterNodeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all orgcodes and their assigned level the headcount approval process has access to.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodes(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel>;
  public getPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodes(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel>>;
  public getPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodes(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel>>;
  public getPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodes(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanOrgCodePagePositionRequestPlanOrgCodesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/org-codes`;
    return this.httpClient.request<SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing position request plans of the current user by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionRequestPlanPagePositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanPagePositionRequestPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>;
  public getPositionRequestPlanPagePositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanPagePositionRequestPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public getPositionRequestPlanPagePositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanPagePositionRequestPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public getPositionRequestPlanPagePositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionRequestPlanPagePositionRequestPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (requestType) {
      requestType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RequestType');
      });
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (locationType) {
      locationType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'LocationType');
      });
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType) {
      positionType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionType');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plans`;
    return this.httpClient.request<SharedPageModelOfHeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets (generates) position survey data for provided query data.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionSurveyDataHeadcountApprovalRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionSurveyHeadcountApprovalPositionSurveyDataModel>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionSurveyDataHeadcountApprovalRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionSurveyHeadcountApprovalPositionSurveyDataModel>>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionSurveyDataHeadcountApprovalRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionSurveyHeadcountApprovalPositionSurveyDataModel>>;
  public getPositionSurveyDataHeadcountApproval(
    requestParameters?: HeadcountApprovalCustomerServiceGetPositionSurveyDataHeadcountApprovalRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error(
        'Required parameter orgCode was null or undefined when calling getPositionSurveyDataHeadcountApproval.'
      );
    }
    const countryIsoAlpha2 = requestParameters?.countryIsoAlpha2;
    const positionClass = requestParameters?.positionClass;
    const siemensEnergyCOINHeadcountApiResponsesMercerJobCodeResponse =
      requestParameters?.siemensEnergyCOINHeadcountApiResponsesMercerJobCodeResponse;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (countryIsoAlpha2 !== undefined && countryIsoAlpha2 !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>countryIsoAlpha2,
        'CountryIsoAlpha2'
      );
    }
    if (positionClass !== undefined && positionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionClass, 'PositionClass');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/position-survey-data`;
    return this.httpClient.request<HeadcountApprovalPositionSurveyHeadcountApprovalPositionSurveyDataModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: siemensEnergyCOINHeadcountApiResponsesMercerJobCodeResponse,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets a dashboard overview of counts of found position requests grouped into states.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getStatesDashboardPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceGetStatesDashboardPositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsDashboardModel>;
  public getStatesDashboardPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceGetStatesDashboardPositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsDashboardModel>>;
  public getStatesDashboardPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceGetStatesDashboardPositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsDashboardModel>>;
  public getStatesDashboardPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceGetStatesDashboardPositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pendingApprovalStepName = requestParameters?.pendingApprovalStepName;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const officeType = requestParameters?.officeType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const queryType = requestParameters?.queryType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const referenceNumber = requestParameters?.referenceNumber;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pendingApprovalStepName) {
      pendingApprovalStepName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'PendingApprovalStepName'
        );
      });
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (officeType) {
      officeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OfficeType');
      });
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'QueryType');
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (referenceNumber) {
      referenceNumber.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ReferenceNumber');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/dashboard`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsDashboardModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all available replacement employees for a planned position.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployees(
    requestParameters?: HeadcountApprovalCustomerServicePagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel>;
  public pagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployees(
    requestParameters?: HeadcountApprovalCustomerServicePagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel>>;
  public pagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployees(
    requestParameters?: HeadcountApprovalCustomerServicePagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel>>;
  public pagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployees(
    requestParameters?: HeadcountApprovalCustomerServicePagePositionRequestPlanReplacementEmployeesPositionRequestPlanReplacementEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plan/replacement`;
    return this.httpClient.request<SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries all available replacement employees.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pagePositionRequestReplacementEmployeesPositionRequestReplacementEmployees(
    requestParameters?: HeadcountApprovalCustomerServicePagePositionRequestReplacementEmployeesPositionRequestReplacementEmployeesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel>;
  public pagePositionRequestReplacementEmployeesPositionRequestReplacementEmployees(
    requestParameters?: HeadcountApprovalCustomerServicePagePositionRequestReplacementEmployeesPositionRequestReplacementEmployeesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel>>;
  public pagePositionRequestReplacementEmployeesPositionRequestReplacementEmployees(
    requestParameters?: HeadcountApprovalCustomerServicePagePositionRequestReplacementEmployeesPositionRequestReplacementEmployeesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel>>;
  public pagePositionRequestReplacementEmployeesPositionRequestReplacementEmployees(
    requestParameters?: HeadcountApprovalCustomerServicePagePositionRequestReplacementEmployeesPositionRequestReplacementEmployeesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/replacement`;
    return this.httpClient.request<SharedPageModelOfHeadcountApprovalReplacementEmployeesReplacementEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a new position request plan.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postPositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServicePostPositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>;
  public postPositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServicePostPositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public postPositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServicePostPositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public postPositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServicePostPositionRequestPlanPositionRequestPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalPositionRequestPlansCreatePositionRequestPlanModel =
      requestParameters?.headcountApprovalPositionRequestPlansCreatePositionRequestPlanModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plans`;
    return this.httpClient.request<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestPlansCreatePositionRequestPlanModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Transfers an existing position request to a new organization.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postPositionRequestTransferPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServicePostPositionRequestTransferPositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsPositionRequestModel>;
  public postPositionRequestTransferPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServicePostPositionRequestTransferPositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public postPositionRequestTransferPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServicePostPositionRequestTransferPositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public postPositionRequestTransferPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServicePostPositionRequestTransferPositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling postPositionRequestTransferPositionRequests.'
      );
    }
    const headcountApprovalPositionRequestsTransferPositionRequestModel =
      requestParameters?.headcountApprovalPositionRequestsTransferPositionRequestModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/transfer`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsPositionRequestModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestsTransferPositionRequestModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Prepares the job ads with their matching template for the given position request data
   * A job ad can be written from an uploaded document as well: send the same &#x60;jobDescriptionAttachmentIds&#x60; that were sent to the job description generation, and the documents behind them go to the agent along with the job description that was distilled from them. Nothing is uploaded here — the files are already stored under those ids.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public prepareJobAds(
    requestParameters?: HeadcountApprovalCustomerServicePrepareJobAdsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfJobAdGenerationMetadata>;
  public prepareJobAds(
    requestParameters?: HeadcountApprovalCustomerServicePrepareJobAdsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfJobAdGenerationMetadata>>;
  public prepareJobAds(
    requestParameters?: HeadcountApprovalCustomerServicePrepareJobAdsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfJobAdGenerationMetadata>>;
  public prepareJobAds(
    requestParameters?: HeadcountApprovalCustomerServicePrepareJobAdsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalJobAdPrepareJobAdModel = requestParameters?.headcountApprovalJobAdPrepareJobAdModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-ads/prepare`;
    return this.httpClient.request<TransactionStatusOfJobAdGenerationMetadata>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalJobAdPrepareJobAdModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates an existing position request plan by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public putPositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServicePutPositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>;
  public putPositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServicePutPositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public putPositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServicePutPositionRequestPlanPositionRequestPlansRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public putPositionRequestPlanPositionRequestPlans(
    requestParameters?: HeadcountApprovalCustomerServicePutPositionRequestPlanPositionRequestPlansRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling putPositionRequestPlanPositionRequestPlans.'
      );
    }
    const headcountApprovalPositionRequestPlansUpdatePositionRequestPlanModel =
      requestParameters?.headcountApprovalPositionRequestPlansUpdatePositionRequestPlanModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/plans/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestPlansUpdatePositionRequestPlanModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing n-1 levels of a business area areas by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceQueryBusinessAreaNMinusOneLevelsBusinessAreasRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfUsersClusterNodesClusterNodeModel>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceQueryBusinessAreaNMinusOneLevelsBusinessAreasRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfUsersClusterNodesClusterNodeModel>>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceQueryBusinessAreaNMinusOneLevelsBusinessAreasRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfUsersClusterNodesClusterNodeModel>>;
  public queryBusinessAreaNMinusOneLevelsBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceQueryBusinessAreaNMinusOneLevelsBusinessAreasRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const businessAreaId = requestParameters?.businessAreaId;
    if (businessAreaId === null || businessAreaId === undefined) {
      throw new Error(
        'Required parameter businessAreaId was null or undefined when calling queryBusinessAreaNMinusOneLevelsBusinessAreas.'
      );
    }
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/business-areas/${this.configuration.encodeParam({ name: 'businessAreaId', value: businessAreaId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/n-minus-one-levels`;
    return this.httpClient.request<SharedPageModelOfUsersClusterNodesClusterNodeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing business areas by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceQueryBusinessAreasBusinessAreasRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfUsersClustersClusterModel>;
  public queryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceQueryBusinessAreasBusinessAreasRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfUsersClustersClusterModel>>;
  public queryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceQueryBusinessAreasBusinessAreasRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfUsersClustersClusterModel>>;
  public queryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountApprovalCustomerServiceQueryBusinessAreasBusinessAreasRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/business-areas`;
    return this.httpClient.request<SharedPageModelOfUsersClustersClusterModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceQueryEmployeeMasterDataEmployeeMasterDataRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalEmployeeReferenceEmployeeModel>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceQueryEmployeeMasterDataEmployeeMasterDataRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalEmployeeReferenceEmployeeModel>>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceQueryEmployeeMasterDataEmployeeMasterDataRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalEmployeeReferenceEmployeeModel>>;
  public queryEmployeeMasterDataEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceQueryEmployeeMasterDataEmployeeMasterDataRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    if (employeeId === null || employeeId === undefined) {
      throw new Error(
        'Required parameter employeeId was null or undefined when calling queryEmployeeMasterDataEmployeeMasterData.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/employee/${this.configuration.encodeParam({ name: 'employeeId', value: employeeId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalEmployeeReferenceEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries position request field values by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceQueryFieldValuesPositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedFieldValuesModel>;
  public queryFieldValuesPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceQueryFieldValuesPositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedFieldValuesModel>>;
  public queryFieldValuesPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceQueryFieldValuesPositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedFieldValuesModel>>;
  public queryFieldValuesPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceQueryFieldValuesPositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const targetProperty = requestParameters?.targetProperty;
    if (targetProperty === null || targetProperty === undefined) {
      throw new Error(
        'Required parameter targetProperty was null or undefined when calling queryFieldValuesPositionRequests.'
      );
    }
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const pendingApprovalStepName = requestParameters?.pendingApprovalStepName;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const locationType = requestParameters?.locationType;
    const officeType = requestParameters?.officeType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgCode = requestParameters?.orgCode;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const queryType = requestParameters?.queryType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const referenceNumber = requestParameters?.referenceNumber;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (targetProperty !== undefined && targetProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>targetProperty, 'TargetProperty');
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (pendingApprovalStepName !== undefined && pendingApprovalStepName !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>pendingApprovalStepName,
        'PendingApprovalStepName'
      );
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (countryGeoClusterNodeId !== undefined && countryGeoClusterNodeId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>countryGeoClusterNodeId,
        'CountryGeoClusterNodeId'
      );
    }
    if (nMinusOneLevelClusterNodeId !== undefined && nMinusOneLevelClusterNodeId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>nMinusOneLevelClusterNodeId,
        'NMinusOneLevelClusterNodeId'
      );
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (officeType !== undefined && officeType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>officeType, 'OfficeType');
    }
    if (hiringManagerGid !== undefined && hiringManagerGid !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>hiringManagerGid,
        'HiringManagerGid'
      );
    }
    if (positionClass !== undefined && positionClass !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionClass, 'PositionClass');
    }
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (orgLevel !== undefined && orgLevel !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgLevel, 'OrgLevel');
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'QueryType');
    }
    if (workforceType !== undefined && workforceType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workforceType, 'WorkforceType');
    }
    if (workTimeType !== undefined && workTimeType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>workTimeType, 'WorkTimeType');
    }
    if (referenceNumber !== undefined && referenceNumber !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>referenceNumber, 'ReferenceNumber');
    }
    if (areCode !== undefined && areCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areCode, 'AreCode');
    }
    if (depthStructure !== undefined && depthStructure !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>depthStructure, 'DepthStructure');
    }
    if (costCenter !== undefined && costCenter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>costCenter, 'CostCenter');
    }
    if (country !== undefined && country !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>country, 'Country');
    }
    if (region !== undefined && region !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>region, 'Region');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/field-values`;
    return this.httpClient.request<SharedFieldValuesModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Query job descriptions and job ads based on input
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceQueryJobDescriptionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountApprovalJobDescriptionsMinimalJobDescriptionModel>;
  public queryJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceQueryJobDescriptionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountApprovalJobDescriptionsMinimalJobDescriptionModel>>;
  public queryJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceQueryJobDescriptionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountApprovalJobDescriptionsMinimalJobDescriptionModel>>;
  public queryJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceQueryJobDescriptionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error('Required parameter orgCode was null or undefined when calling queryJobDescriptions.');
    }
    const jobCodeId = requestParameters?.jobCodeId;
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (orgCode !== undefined && orgCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orgCode, 'OrgCode');
    }
    if (jobCodeId !== undefined && jobCodeId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>jobCodeId, 'JobCodeId');
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-descriptions`;
    return this.httpClient.request<SharedPageModelOfHeadcountApprovalJobDescriptionsMinimalJobDescriptionModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all orgcodes and their assigned level the headcount approval process has access to.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryOrgCodesHeadcountApproval(
    requestParameters?: HeadcountApprovalCustomerServiceQueryOrgCodesHeadcountApprovalRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: HeadcountApprovalCustomerServiceQueryOrgCodesHeadcountApprovalRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel>>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: HeadcountApprovalCustomerServiceQueryOrgCodesHeadcountApprovalRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel>>;
  public queryOrgCodesHeadcountApproval(
    requestParameters?: HeadcountApprovalCustomerServiceQueryOrgCodesHeadcountApprovalRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/org-codes`;
    return this.httpClient.request<SharedPageModelOfHeadcountApprovalOrgCodesHeadcountApprovalOrgCodeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Gets all comments of an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPositionRequestComments(
    requestParameters?: HeadcountApprovalCustomerServiceQueryPositionRequestCommentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<CommunicationsCommentsCommentModel>>;
  public queryPositionRequestComments(
    requestParameters?: HeadcountApprovalCustomerServiceQueryPositionRequestCommentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<CommunicationsCommentsCommentModel>>>;
  public queryPositionRequestComments(
    requestParameters?: HeadcountApprovalCustomerServiceQueryPositionRequestCommentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<CommunicationsCommentsCommentModel>>>;
  public queryPositionRequestComments(
    requestParameters?: HeadcountApprovalCustomerServiceQueryPositionRequestCommentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    if (positionRequestId === null || positionRequestId === undefined) {
      throw new Error(
        'Required parameter positionRequestId was null or undefined when calling queryPositionRequestComments.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/comments`;
    return this.httpClient.request<Array<CommunicationsCommentsCommentModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing position requests by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceQueryPositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountApprovalPositionRequestsPositionRequestModel>;
  public queryPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceQueryPositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountApprovalPositionRequestsPositionRequestModel>>;
  public queryPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceQueryPositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountApprovalPositionRequestsPositionRequestModel>>;
  public queryPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceQueryPositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const pagingPage = requestParameters?.pagingPage;
    const pagingSize = requestParameters?.pagingSize;
    const sortingOrderBy = requestParameters?.sortingOrderBy;
    const sortingProperty = requestParameters?.sortingProperty;
    const pendingApprovalStepName = requestParameters?.pendingApprovalStepName;
    const requestType = requestParameters?.requestType;
    const countryGeoClusterNodeId = requestParameters?.countryGeoClusterNodeId;
    const nMinusOneLevelClusterNodeId = requestParameters?.nMinusOneLevelClusterNodeId;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const locationType = requestParameters?.locationType;
    const officeType = requestParameters?.officeType;
    const hiringManagerGid = requestParameters?.hiringManagerGid;
    const positionClass = requestParameters?.positionClass;
    const orgLevel = requestParameters?.orgLevel;
    const positionType = requestParameters?.positionType;
    const queryType = requestParameters?.queryType;
    const workforceType = requestParameters?.workforceType;
    const workTimeType = requestParameters?.workTimeType;
    const referenceNumber = requestParameters?.referenceNumber;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const costCenter = requestParameters?.costCenter;
    const country = requestParameters?.country;
    const region = requestParameters?.region;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (pagingPage !== undefined && pagingPage !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingPage, 'Paging.Page');
    }
    if (pagingSize !== undefined && pagingSize !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>pagingSize, 'Paging.Size');
    }
    if (sortingOrderBy !== undefined && sortingOrderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingOrderBy, 'Sorting.OrderBy');
    }
    if (sortingProperty !== undefined && sortingProperty !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>sortingProperty, 'Sorting.Property');
    }
    if (pendingApprovalStepName) {
      pendingApprovalStepName.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'PendingApprovalStepName'
        );
      });
    }
    if (requestType !== undefined && requestType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>requestType, 'RequestType');
    }
    if (countryGeoClusterNodeId) {
      countryGeoClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'CountryGeoClusterNodeId'
        );
      });
    }
    if (nMinusOneLevelClusterNodeId) {
      nMinusOneLevelClusterNodeId.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'NMinusOneLevelClusterNodeId'
        );
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith) {
      orgCodeStartsWith.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCodeStartsWith');
      });
    }
    if (locationType !== undefined && locationType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>locationType, 'LocationType');
    }
    if (officeType) {
      officeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OfficeType');
      });
    }
    if (hiringManagerGid) {
      hiringManagerGid.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'HiringManagerGid');
      });
    }
    if (positionClass) {
      positionClass.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'PositionClass');
      });
    }
    if (orgLevel) {
      orgLevel.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgLevel');
      });
    }
    if (positionType !== undefined && positionType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>positionType, 'PositionType');
    }
    if (queryType !== undefined && queryType !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>queryType, 'QueryType');
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (workTimeType) {
      workTimeType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkTimeType');
      });
    }
    if (referenceNumber) {
      referenceNumber.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ReferenceNumber');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (country) {
      country.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Country');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests`;
    return this.httpClient.request<SharedPageModelOfHeadcountApprovalPositionRequestsPositionRequestModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceQueryReferenceEmployeesEmployeeMasterDataRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<HeadcountApprovalEmployeeReferenceEmployeeModel>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceQueryReferenceEmployeesEmployeeMasterDataRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<HeadcountApprovalEmployeeReferenceEmployeeModel>>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceQueryReferenceEmployeesEmployeeMasterDataRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<HeadcountApprovalEmployeeReferenceEmployeeModel>>>;
  public queryReferenceEmployeesEmployeeMasterData(
    requestParameters?: HeadcountApprovalCustomerServiceQueryReferenceEmployeesEmployeeMasterDataRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error(
        'Required parameter orgCode was null or undefined when calling queryReferenceEmployeesEmployeeMasterData.'
      );
    }
    const search = requestParameters?.search;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/employee/reference/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<HeadcountApprovalEmployeeReferenceEmployeeModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing countries of a region by specified parameters. Can also query all countries if no region is supplied.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRegionCountriesCountries(
    requestParameters?: HeadcountApprovalCustomerServiceQueryRegionCountriesCountriesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfUsersClusterNodesCountryClusterNodeModel>;
  public queryRegionCountriesCountries(
    requestParameters?: HeadcountApprovalCustomerServiceQueryRegionCountriesCountriesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfUsersClusterNodesCountryClusterNodeModel>>;
  public queryRegionCountriesCountries(
    requestParameters?: HeadcountApprovalCustomerServiceQueryRegionCountriesCountriesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfUsersClusterNodesCountryClusterNodeModel>>;
  public queryRegionCountriesCountries(
    requestParameters?: HeadcountApprovalCustomerServiceQueryRegionCountriesCountriesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const regionIds = requestParameters?.regionIds;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (regionIds) {
      regionIds.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'RegionIds');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/countries`;
    return this.httpClient.request<SharedPageModelOfUsersClusterNodesCountryClusterNodeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Queries existing regions by specified parameters.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRegionsRegions(
    requestParameters?: HeadcountApprovalCustomerServiceQueryRegionsRegionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfUsersClustersClusterModel>;
  public queryRegionsRegions(
    requestParameters?: HeadcountApprovalCustomerServiceQueryRegionsRegionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfUsersClustersClusterModel>>;
  public queryRegionsRegions(
    requestParameters?: HeadcountApprovalCustomerServiceQueryRegionsRegionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfUsersClustersClusterModel>>;
  public queryRegionsRegions(
    requestParameters?: HeadcountApprovalCustomerServiceQueryRegionsRegionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'Search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/regions`;
    return this.httpClient.request<SharedPageModelOfUsersClustersClusterModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Checks a finished job ad before the position request is submitted.
   * The quality gate behind Submit Request. The job ad is judged as a whole — every block, in every language it is written in — against the instruction its template\&#39;s admin configured plus the agent\&#39;s standing rules, and the answer is one verdict: approved or rejected, a plain-language summary, the improvements to make, and the findings behind them.  &lt;b&gt;Nothing is written and nothing is gated.&lt;/b&gt; The job ad comes back unchanged because it is never touched, and a rejected verdict does not stop a submission — the manager fixes what was found or submits anyway. To keep the verdict with the request, send it back as &#x60;Review&#x60; on that job ad when saving or submitting; only the newest one is stored, and it is what Job Ad Details shows afterwards. One job ad per call: a request matching three templates is three calls, which is also what lets the results appear as they arrive. Send the same documents the prepare transaction produced, including the &#x60;threadId&#x60; it reported for this template — the manager\&#39;s uploaded documents live on that conversation. Refused with a validation error, before the agent is asked anything, when the job ad has not been written yet: it is unfinished rather than poor, and generating it comes first.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public reviewJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceReviewJobAdsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalJobAdReviewJobAdResultModel>;
  public reviewJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceReviewJobAdsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalJobAdReviewJobAdResultModel>>;
  public reviewJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceReviewJobAdsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalJobAdReviewJobAdResultModel>>;
  public reviewJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceReviewJobAdsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalJobAdReviewJobAdModel = requestParameters?.headcountApprovalJobAdReviewJobAdModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-ads/review`;
    return this.httpClient.request<HeadcountApprovalJobAdReviewJobAdResultModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalJobAdReviewJobAdModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Proxies an AG-UI run to the job ad agent and streams the agent\&#39;s events straight back as server-sent events, so the chat next to the job ad can show the reply while it is still being written.
   * The request body is the AG-UI run input and is forwarded verbatim — the agent owns that contract, and the frontend is the only party that interprets the events coming back. Nothing is read or written here beyond passing the run along.
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public streamAgentRunJobAd(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public streamAgentRunJobAd(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public streamAgentRunJobAd(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public streamAgentRunJobAd(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/headcount-approval/job-ad/ag-ui`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * Adds one language to a job ad that has already been generated.
   * Send the job ad and its resolved template as they came out of the prepare transaction. The languages the job ad already holds are carried over untouched, and only the blocks the template lets the agent write are translated by it — locked blocks, section headings and building blocks take the wording the template\&#39;s author wrote for that language.  Refused with a validation error, before the agent is asked anything, when the language is not one the template supports or is one the job ad already holds.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public translateJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceTranslateJobAdsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalJobAdTranslateJobAdResultModel>;
  public translateJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceTranslateJobAdsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalJobAdTranslateJobAdResultModel>>;
  public translateJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceTranslateJobAdsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalJobAdTranslateJobAdResultModel>>;
  public translateJobAds(
    requestParameters?: HeadcountApprovalCustomerServiceTranslateJobAdsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalJobAdTranslateJobAdModel = requestParameters?.headcountApprovalJobAdTranslateJobAdModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-ads/translate`;
    return this.httpClient.request<HeadcountApprovalJobAdTranslateJobAdResultModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalJobAdTranslateJobAdModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates an existing job description.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceUpdateJobDescriptionsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalJobDescriptionsJobDescriptionModel>;
  public updateJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceUpdateJobDescriptionsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalJobDescriptionsJobDescriptionModel>>;
  public updateJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceUpdateJobDescriptionsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalJobDescriptionsJobDescriptionModel>>;
  public updateJobDescriptions(
    requestParameters?: HeadcountApprovalCustomerServiceUpdateJobDescriptionsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updateJobDescriptions.');
    }
    const headcountApprovalJobDescriptionsUpdateJobDescriptionModel =
      requestParameters?.headcountApprovalJobDescriptionsUpdateJobDescriptionModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/job-descriptions/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalJobDescriptionsJobDescriptionModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalJobDescriptionsUpdateJobDescriptionModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Updates an existing position request draft by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceUpdatePositionRequestDraftsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>;
  public updatePositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceUpdatePositionRequestDraftsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public updatePositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceUpdatePositionRequestDraftsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>>;
  public updatePositionRequestDrafts(
    requestParameters?: HeadcountApprovalCustomerServiceUpdatePositionRequestDraftsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePositionRequestDrafts.');
    }
    const headcountApprovalPositionRequestDraftsUpdatePositionRequestDraftModel =
      requestParameters?.headcountApprovalPositionRequestDraftsUpdatePositionRequestDraftModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/drafts/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalPositionRequestDraftsPositionRequestDraftModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestDraftsUpdatePositionRequestDraftModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Creates a new position request (as a \&#39;create from draft by its unique id\&#39;) or updates an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceUpdatePositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsPositionRequestModel>;
  public updatePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceUpdatePositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public updatePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceUpdatePositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public updatePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceUpdatePositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling updatePositionRequests.');
    }
    const headcountApprovalPositionRequestsUpdatePositionRequestModel =
      requestParameters?.headcountApprovalPositionRequestsUpdatePositionRequestModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsPositionRequestModel>(
      'put',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestsUpdatePositionRequestModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Validates the position class, career level and career stream of a position request against the head position of the org code the position is requested for.
   * Meant to be called while the request dialog is open, whenever the org code, the job code or the position class changes. Blocking messages are enforced again on create and update.  Returns 400 when the org code is outside the requester\&#39;s jurisdiction, the same way creating or updating the request would. That is not a validation message, so there is nothing to display at a field for it.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public validatePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceValidatePositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsValidationPositionRequestValidationResponseModel>;
  public validatePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceValidatePositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsValidationPositionRequestValidationResponseModel>>;
  public validatePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceValidatePositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsValidationPositionRequestValidationResponseModel>>;
  public validatePositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceValidatePositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const headcountApprovalPositionRequestsValidationValidatePositionRequestInputQuery =
      requestParameters?.headcountApprovalPositionRequestsValidationValidatePositionRequestInputQuery;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/validate`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsValidationPositionRequestValidationResponseModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountApprovalPositionRequestsValidationValidatePositionRequestInputQuery,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Vetos an existing position request by its unique id.
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public vetoPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceVetoPositionRequestsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsPositionRequestModel>;
  public vetoPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceVetoPositionRequestsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public vetoPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceVetoPositionRequestsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public vetoPositionRequests(
    requestParameters?: HeadcountApprovalCustomerServiceVetoPositionRequestsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling vetoPositionRequests.');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/api/v1/master/positions/requests/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/veto`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsPositionRequestModel>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
